{
  "title": "How to Create a Rubric",
  "description": "Create a rubric with scoring items and weights, for judges to score against.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, the competition has a rubric that can be assigned to a round, and judges will score against it item by item.",
  "roleNote": "Competition Admin",
  "prerequisites": [
    "You have admin access to this competition",
    "You've planned out the scoring items and their weights"
  ],
  "pathLabel": "Organizer Console → Competition Settings → Rubrics",
  "steps": [
    {
      "title": "1. Create the rubric",
      "description": "Enter a name and description for the rubric, and add at least one scoring item; each item can have a name, description, score range (min/max), and weight. Each criterion can also carry scoring bands (lowest score, highest score and a description, up to 12) that judges can expand while scoring. Totals are always out of 100: each criterion counts as score ÷ its own maximum × weight, so scoring 0 to 10 or 0 to 100 both work."
    },
    {
      "title": "2. Confirm the weights add up to 100",
      "description": "The system validates that every scoring item's weight adds up to exactly 100; anything else (more or less) is rejected with an error, and you'll need to adjust the weights before submitting."
    },
    {
      "title": "3. Name the version (optional)",
      "description": "You can give an individual rubric version a label (e.g. \"Preliminary\", \"Final\") to make it easy to tell apart when the same rubric is reused across rounds; this is a pure name tag and never triggers a new version to be cloned."
    },
    {
      "title": "4. Bind it to a round",
      "description": "In the round's settings, select the rubric it should use — from then on, every judge assignment in that round shows a scoring form built from this rubric."
    }
  ],
  "afterward": [
    "The rubric is created and can be selected in a round's settings",
    "When a judge opens their scoring page, they see a scoring form listing every item from this rubric"
  ],
  "nextSteps": "Once the rubric is built, see \"How to Create Rounds and Configure Their Schedule\" to bind it to a round, and \"How to Invite Judges\" to start inviting judges.",
  "faq": [
    {
      "q": "Can I still edit the scoring items once judges have started scoring?",
      "a": "Yes, but the system handles it differently depending on whether any scores already exist. If no score exists yet, replacing the items applies directly to the current version. If scores already exist, the system automatically creates a new version (V+1) to carry your changes — the old version's content, tied to the existing scores, is left untouched and never overwritten."
    },
    {
      "q": "Can a competition only have one rubric?",
      "a": "No — you can create multiple rubrics (e.g. different scoring items for the preliminary and final rounds) and bind each one to its own round."
    },
    {
      "q": "What does the rubric version name do?",
      "a": "It's purely a display label (e.g. to distinguish \"Preliminary\" from \"Final\" versions); naming alone never creates a new version or affects existing scores — it's a pure metadata edit."
    }
  ]
}
